import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './Dock.css';
import DockSection from './dock/DockSection';
import { useDockData, useDockCleanup } from './dock/DockHooks';
import DockUtils from './dock/DockUtils';
import logger from '../utils/logger';
import languageManager from '../utils/languageManager';

// 全局Dock功能
window.Dock = {
  // 测试函数
  testWebsiteClick: function() {
    const testWebsite = {
      id: 'test',
      name: '测试网站',
      url: 'https://example.com',
      title: '测试网站标题'
    };
    
    console.log('[测试] 触发websiteClick事件', testWebsite);
    const clickEvent = new CustomEvent('websiteClick', {
      detail: { website: testWebsite }
    });
    window.dispatchEvent(clickEvent);
    
    // 检查localStorage
    setTimeout(() => {
      const clickCounts = localStorage.getItem('websiteClickCount');
      console.log('[测试] localStorage数据:', clickCounts);
    }, 100);
  },
  
  addRecentApp: function(app) {
    logger.log('🟢 添加到最近使用', app);
    return DockUtils.addToRecentApps(app);
  }
};

const Dock = ({ onIconClick }) => {
  logger.log('Init', 'Dock组件初始化');
  
  // 从Redux获取Dock显示设置
  const { dockVisible } = useSelector(state => state.settings);
  
  const dockContainerRef = useRef(null);
  
  // 语言刷新状态
  const [languageKey, setLanguageKey] = useState(0);
  
  // 监听语言变更
  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguageKey(prev => prev + 1);
    };
    
    // 注册语言变更监听器，返回取消监听的函数
    const unsubscribe = languageManager.addListener(handleLanguageChange);
    
    return unsubscribe;
  }, []);
  
  // 使用自定义Hooks管理数据
  const { recentApps, mostUsedApps } = useDockData();
  
  // 记录数据状态
  logger.log('Dock数据', { recentApps, mostUsedApps });
  
  // 使用清理Hook
  useDockCleanup();

  // 如果Dock被设置为不可见，则不渲染
  if (!dockVisible) {
    return null;
  }

  return (
    <div 
      className="dock-container"
      ref={dockContainerRef}
    >
      <div className="dock">
        {/* 最近使用区域 */}
        <DockSection
          key={`recent-${languageKey}`}
          title={languageManager.t('dock.recentUsed')}
          apps={recentApps}
          section="recent-apps"
          maxItems={3}
          onIconClick={onIconClick}
        />
        
        <div className="dock-divider" />
        
        {/* 最常用网站区域 */}
        <DockSection
          key={`most-used-${languageKey}`}
          title={languageManager.t('dock.mostUsed')}
          apps={mostUsedApps}
          section="most-used-apps"
          maxItems={3}
          onIconClick={onIconClick}
        />
      </div>
    </div>
  );
};

export default Dock;
